import React from 'react';
import { v4 } from 'uuid';

import CompoundExecutionStepDetails from '../../compound/execution/StepDetails';
import {
  defaultCompoundStepCount,
  defaultCompoundStepCountOperator,
} from '../../../constants/compound';
import { isStepEnabled } from '../../../utils/compound';
import CustomSelect from '../../common/Select';
import { views } from '../../../constants/event';
import ConversionChart from '../../../chart/tabcharts/ConversionChart';

const FunnelExecutionDetails = ({
  chart,
  stepCounters = [],
  steps,
  perStepClosingRangeEnabled,
  view,
  onChangeView,
}) => {
  const totalCount = stepCounters.length ? stepCounters[0].count : 0;
  let index = 0;

  let optionalStepIndex = steps.findIndex((c) => c.optional);

  optionalStepIndex =
    optionalStepIndex > -1 && steps[optionalStepIndex].enabled ? optionalStepIndex : steps.length;

  // флаг для отображения Closing range
  let isStepClosingRange = false;
  return (
    <div>
      {steps.map((step, i) => {
        const stepCounter = stepCounters[index] || {};
        // Closing range не должен отображаться для первых шагов и задизейбленных шагов.
        // если первый шаг был задизейблен то второй шаг будет считаться первым (Closing range не отображается)
        if (!isStepClosingRange && i !== 0) {
          isStepClosingRange = steps[i - 1].enabled !== false;
        }

        // больше чем 1 подряд optional быть не может, поэтому если предыдущий шаг был optional, то срабатывает ind-2.
        const prevStep = (ind) =>
          (stepCounters[ind - 1] || {}).count !== undefined
            ? (stepCounters[ind - 1] || {}).count
            : (stepCounters[ind - 2] || {}).count;

        const stepDetails = (
          <CompoundExecutionStepDetails
            totalCount={totalCount}
            stepNum={index + 1}
            prevStepCount={prevStep(index)} // first iteration: negative indexes are treated as properties, so it's ok
            prevStepOptionalCount={
              i > optionalStepIndex ? (stepCounters[index - 1] || {}).optionalCount : undefined
            }
            stepCount={stepCounter.count}
            optionalStepCount={i >= optionalStepIndex ? stepCounter.optionalCount : undefined}
            stepEvent={step.event}
            stepFilter={step.filter}
            stepDescription={step.descriptionVisible && step.description}
            stepClosingRange={
              perStepClosingRangeEnabled && isStepClosingRange ? step.closingRange : undefined
            }
            stepRequiredCount={step.count || defaultCompoundStepCount}
            stepRequiredCountOperator={step.countOperator || defaultCompoundStepCountOperator}
            disabled={!isStepEnabled(step.enabled)}
            key={v4()}
            optional={step.optional}
          />
        );

        if (isStepEnabled(step.enabled)) {
          index += 1;
        }

        return stepDetails;
      })}
      {chart ? (
        <div>
          <div style={{ margin: '10px 0px 10px' }}>
            <span style={{ marginRight: '5px' }}>View:</span>
            <CustomSelect
              allowClear={false}
              value={view}
              values={[views.CHART, views.COLUMN_CHART]}
              style={{ width: 'auto', minWidth: 85 }}
              className="ant-select-border-bottom"
              onChange={onChangeView}
            />
          </div>
          <ConversionChart />
        </div>
      ) : undefined}
    </div>
  );
};

export default FunnelExecutionDetails;
